import{createMediaCondition as r}from"../../themes/breakpoints.js";import{useMediaQuery as e}from"../useMediaQuery/useMediaQuery.js";var o={up:"min",down:"max"},i=function(i,m){var t=r(i,o[m]);return e(t)};export{i as useBreakpoint};
//# sourceMappingURL=useBreakpoint.js.map
